export default "__VITE_ASSET__CiZx25rp__"